// middleware/auth.global.js

export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.startsWith('/api/')) {
    return
  }

  if (import.meta.server) {
    // 서버에서 요청 헤더 확인
    const headers = useRequestHeaders(['cookie'])
    console.log('🍪 서버 Cookie 헤더:', headers.cookie)
  }
  const isServer = import.meta.server
  const isClient = import.meta.client

  console.log('=== 라우팅 미들웨어 시작 ===')
  console.log('환경:', isServer ? '서버' : '클라이언트')
  console.log('이동 경로:', to.path)

  try {
    
    // 🔥 Cookie 직접 읽기 (서버/클라이언트 모두)
    const authCookie = useCookie('auth')
    
    let hasAuth = false

    if (authCookie.value) {
      try {
        const authData = typeof authCookie.value === 'string' 
          ? JSON.parse(authCookie.value) 
          : authCookie.value
        hasAuth = !!authData?.token
        console.log('✅ Cookie 토큰 확인:', hasAuth, '(환경:', isServer ? '서버' : '클라이언트', ')')
        // console.log('Cookie 토큰 :', authData?.token)

      } catch (e) {
        console.error('❌ Cookie 파싱 에러:', e)
      }
    } else {
      console.log('⚠️ Cookie 없음', '(환경:', isServer ? '서버' : '클라이언트', ')')
    }

    // 루트 경로 처리
    if (to.path === '/' || to.path === '/view' || to.path === '/view/') {
      console.log('루트 경로 /home으로 리다이렉트')
      return navigateTo('/home', { replace: true })
      
    }

    // 로그인 페이지인데 이미 로그인된 경우 → /home 리다이렉트
    const LOGIN_PATHS = ['/view/login', '/view/loginId', '/login', '/loginId']
    if (LOGIN_PATHS.includes(to.path) && hasAuth) {
      return navigateTo('/home', { replace: true })
    }

    // 로그인 페이지로 이동할 때 호출한 페이지를 저장 → 로그인 완료 후 navigateAfterPage()로 복귀
    if (LOGIN_PATHS.includes(to.path) && from && from.path !== to.path && !isFromPathIgnored(from.fullPath)) {
      useCookie('fromPath', FROM_PATH_COOKIE_OPTIONS).value = from.fullPath
    }

  } catch (error) {
    console.error('라우팅 미들웨어 에러:', error)
    return navigateTo('/error')
  }
})